module.exports = __webpack_public_path__ + "static/media/outlet_settings.56289387.svg";